import axios, { AxiosInstance } from 'axios'
import { ApiConfig } from '..'
import authConfig from '../../../../utils/authConfig'

export default function getAxiosInstance(apiInfo: ApiConfig): AxiosInstance {
  const withAccessTokenHeader = {
    headers: { Authorization: `Bearer ${authConfig.getAccessToken()}` },
  }

  const baseURL = process.env.BASE_URL
  const apiConfig = {
    baseURL: !baseURL ? 'http://localhost:8088/' : `${baseURL}/`,
    ...(apiInfo.withAccessToken && withAccessTokenHeader),
  }

  return axios.create(apiConfig)
}
